import axios from "axios";
import {
  GET_PORTAL_AUDIT_LOGS_FAIL,
  GET_PORTAL_AUDIT_LOGS_REQUEST,
  GET_PORTAL_AUDIT_LOGS_SUCCESS,
} from "../constants/adminPortal_portalAuditLogsConstants";
import { api } from "../../mockData";

export const getPortalAuditLogs = (data) => async (dispatch) => {
  const token = JSON.parse(localStorage.getItem("admin"));

  try {
    dispatch({ type: GET_PORTAL_AUDIT_LOGS_REQUEST });

    const response = await axios.post(
      `${api.dev}/api/portalauditlog`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
        maxBodyLength: Infinity,
      }
    );

    dispatch({
      type: GET_PORTAL_AUDIT_LOGS_SUCCESS,
      payload: response?.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_PORTAL_AUDIT_LOGS_FAIL,
      payload: error?.response?.data?.message || error.message,
    });
  }
};

export const clearPortalAuditLogs =
  (beforeDate, onSuccess, onError) => async (dispatch) => {
    const token = JSON.parse(localStorage.getItem("admin"));
    try {
      const response = await axios.delete(`${api.dev}/api/portalauditlog`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
        data: { before_date: beforeDate },
      });
      if (onSuccess) onSuccess(response?.data);
    } catch (error) {
      const msg = error?.response?.data?.message || error.message;
      if (onError) onError(msg);
    }
  };
